import { inject, Injectable } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { environment } from '../../../environments/environment';
import {
  AUTH_MAIN_ROUTE,
  AUTH_ROUTES,
} from '../../constants/auth.routing.constants';
import { Router } from '@angular/router';
import { AppStorage } from '../../enums/app-storage';
import { CookieService } from '../../services/cookie/cookie.service';
import { LAST_WORKSPACE_COOKIE_DAYS } from '../workspace/workspace.helper';

@Injectable({
  providedIn: 'root',
})
export class LogoutHelperService {
  readonly authService = inject(AuthService);
  readonly router = inject(Router);
  readonly cookieService = inject(CookieService);

  handleLogout() {
    this.checkForlastWorkspace();
    this.authService.clearLocalStorageData();
    if (location.hostname.includes('localhost')) {
      this.router.navigate([`/${AUTH_MAIN_ROUTE}/${AUTH_ROUTES.LOGIN}`]);
    } else {
      location.href = `https://${environment.domain}/${AUTH_MAIN_ROUTE}/${AUTH_ROUTES.LOGIN}`;
    }
    this.authService.isLogoutLoading.set(false);
  }

  checkForlastWorkspace() {
    const lastWorkspace = this.cookieService.get(AppStorage.lastWorkspace);
    const selectedWorkspace = this.authService.selectedWorkspace();
    if (!lastWorkspace) {
      this.cookieService.set(
        AppStorage.lastWorkspace,
        selectedWorkspace?.slug ?? '',
        {
          expires: LAST_WORKSPACE_COOKIE_DAYS,
        }
      );
    }
  }
}
